import { MentorshipDetails, useFindMentorship } from "@/lib/api/mentorships";
import { useSafeChannelContext } from "@/lib/sendbird/use-safe-channel-context";
import { useSendbirdStateContext } from "@sendbird/uikit-react";
import { useMemo } from "react";

export function useGetChannelMentorship() {
  const store = useSendbirdStateContext();
  const channelStore = useSafeChannelContext();
  const channel = channelStore?.currentGroupChannel;

  const membersExcludingMentor = channel?.members?.filter(
    (member) => member.userId !== store.config.userId,
  );

  const menteeId = membersExcludingMentor?.[0]?.userId || "";
  const mentorId = store.config.userId || "";

  const { data: mentorship, isLoading } = useFindMentorship(
    mentorId,
    menteeId,
  );
  const mentorshipWithChannelAvatars = useMemo(() => {
    if (!mentorship) return mentorship;

    return withChannelAvatars(mentorship, {
      mentorAvatarUrl: channel?.members?.find(
        (member) => member.userId === mentorship.mentor.id,
      )?.profileUrl,
      menteeAvatarUrl: channel?.members?.find(
        (member) => member.userId === mentorship.mentee.id,
      )?.profileUrl,
    });
  }, [channel?.members, mentorship]);

  return {
    mentorship: mentorshipWithChannelAvatars,
    isLoading,
  };
}

function withChannelAvatars(
  mentorship: MentorshipDetails,
  avatars: {
    mentorAvatarUrl?: string | null;
    menteeAvatarUrl?: string | null;
  },
): MentorshipDetails {
  return {
    ...mentorship,
    mentor: {
      ...mentorship.mentor,
      profile_picture_url:
        mentorship.mentor.profile_picture_url ?? avatars.mentorAvatarUrl,
    },
    mentee: {
      ...mentorship.mentee,
      profile_picture_url:
        mentorship.mentee.profile_picture_url ?? avatars.menteeAvatarUrl,
    },
  };
}
